import { Tag } from 'antd';
import { AthleteTeamMember, EventRoleStatus, STATUS } from '@type/db-types';
import { statusKeyToLabel } from '@utils/team-table-utils';

export default function RenderStatusTag(
    props: Pick<AthleteTeamMember, 'teamStatus'> | Pick<EventRoleStatus, 'membershipStatus'>,
) {
    const status = 'teamStatus' in props ? props.teamStatus : props.membershipStatus;
    return status === STATUS.ACTIVE ? (
        <Tag color="success">Active</Tag>
    ) : status === STATUS.INVITED ? (
        <Tag color="warning">Invited</Tag>
    ) : (
        <Tag color="error">{status ? statusKeyToLabel(status) : 'None'}</Tag>
    );
}
